module.exports = "/images/paypal.svg";